import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import tasksReducer from './slices/tasksSlice';
import projectReducer from './slices/projectSlice';
import pmDashboardReducer from './slices/pmDashboardSlice';
import procurementReducer from './slices/procurementSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tasks: tasksReducer,
    projects: projectReducer,
    pmDashboard: pmDashboardReducer,
    procurement: procurementReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch & ((action: any) => any);
